import { DropdownItem, DropdownList } from '@/main/store/@types/dropdown.d';

export class ArchivDropdownList implements DropdownList {
	ProvozovnaId = [];
	ZakazkaDruh = [];
	VyrobekvozOzn = [];
	SmluvpartnerPzn = [];
	SmVariaList = [];

	[key: string]: DropdownItem[];
}

export class Filter {
	VyrazenPrp: boolean | null = null;
	NabidkaPrp: boolean | null = null;
	PripravaPrp: boolean | null = null;
	OtevrenePrp: boolean | null = null;
	UvolnenePrp: boolean | null = null;
	UzavrenePrp: boolean | null = null;
	ProvozovnaId: number | null = null;
	ZakazkaDruh: string | null = null;
	ZakazkaNr: number | null = null;
	ZakazkaText: string | null = null;
	VyrobekvozOzn: string | null = null;
	Spz: string | null = null;
	KaroserieNr: string | null = null;
	ZakazkaNrRef: number | null = null;
	ZakaznikId: number | null = null;
	ZakaznikIdText: string | null = null;
	VstupPracId: number | null = null;
	VstupPracIdText: string | null = null;
	VstupDatOd: string | null = null;
	VstupDatDo: string | null = null;
	OtevreniDatOd: string | null = null;
	OtevreniDatDo: string | null = null;
	UzavreniDatOd: string | null = null;
	UzavreniDatDo: string | null = null;
	PnvId: number | null = null;
	PovId: number | null = null;
	OzakazkaId: number | null = null;
	OzakazkaIdText: string | null = null;
	OzakazkaIdNr = null as number | null;
	DokladPfx: string | null = null;
	DokladNr: number | null = null;
	CekajiciRyoPrp: boolean | null = null;
	DzmPrp: boolean | null = null;
	ZakazkyUzivatelePrp: boolean | null = null;
	PojistovnaId: number | null = null;
	PojistovnaIdText: string | null = null;
	LeaszakaznikId: number | null = null;
	LeaszakaznikIdText: string | null = null;
	LeasCisSchval: string | null = null;
	LeaszakaznikIdPrp: boolean | null = null;
	LeasCisSchvalPrp: boolean | null = null;
	PojistCisPu: string | null = null;
	PojistCisExtzaklikv: string | null = null;
	PojistovnaIdPrp: boolean | null = null;
	PojistCisPuPrp: boolean | null = null;
	PojistCisExtzaklikvPrp: boolean | null = null;
	SmluvpartnerId: number | null = null;
	SmluvpartnerIdText: string | null = null;
	SmluvpartnerPzn: number | null = null;
	SmVariaList: number[] = [];
}
